import classNames from 'classnames';

import { getTagAccentVar } from '../../helpers/tagColors';

import './TagGroup.scss';

const TagGroup = ({ name, classes, tags, selectedTagId, onTagClick }) => {
  const listClasses = classNames(name, classes);

  return (
    <div className="tag-group horizontal-menu">
      <ul className={listClasses}>
        {tags.map((tag) => {
          const accent = getTagAccentVar(tag.color);

          return (
            <li
              onClick={() => onTagClick(tag)}
              key={tag._id}
              data-tag-id={tag._id}
              className={classNames({ active: tag._id === selectedTagId })}
              // Every color rule for the pill derives from this one accent, so a tag only
              // has to name its hue. Tags without a color fall back to the neutral accent.
              style={accent ? { '--tag-color': accent } : undefined}
            >
              {/* data-text lets the CSS reserve the bold width up front, so selecting a
                  pill doesn't nudge the rest of the row sideways. */}
              <span className="tag-group__tag-text" data-text={tag.name}>
                {tag.name}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default TagGroup;
